import { render, staticRenderFns } from "./RightOption.vue?vue&type=template&id=af8baf7a&scoped=true&"
import script from "./RightOption.vue?vue&type=script&lang=js&"
export * from "./RightOption.vue?vue&type=script&lang=js&"
import style0 from "./RightOption.vue?vue&type=style&index=0&id=af8baf7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af8baf7a",
  null
  
)

export default component.exports